import React from 'react';
import {Grid} from '@material-ui/core';

const Capabilities= () => {
    return (
      <div>
          <Grid container>
            <Grid item xs={12}>      
            <h1>Company Overview</h1>
            <p>It gives us great pleasure to introduce ourselves as<strong> PES Group of Companies </strong>, dealing with
          complete solution for process industries like Breweries, Dairy, Beverages, Fruit Juice processing
          & Pharmaceuticals.</p>
          <p></p>
          <p><span style={{color: "red"}}><strong>PES Group</strong></span> consists of 3 major companies namely</p>
          <p></p>
          <ul>
            <strong>
            <li style={{color:"#1F487C"}}>PES Stainless Equipments Pvt Ltd, Delhi</li>
            <li style={{color:"#1F487C"}}>Project Engineering Services, Delh</li>
            <li style={{color:"#1F487C"}}>EN Projects & Engineering Industries Pvt Ltd, Gurgaon</li>
            </strong>
          </ul>
          <p></p>
          <u><h4>Overview</h4></u>
          <p></p>
          <ol>
            <li>
              <strong style={{color: "red"}}>PES Stainless Equipments Pvt Ltd</strong> is an Authorized Distributor for:-
              <p></p>
                <ul>
                  <li><strong style={{color:"#1F487C"}}>PALL INDIA PVT LTD:-</strong> We offer a comprehensive range of ‘PALL’ process filtration Products .
                     PALL Corporation provide filtration, separation & purification solutions for Fluid Management 
                     Needs</li>
                  <li><strong style={{color:"#1F487C"}}>ANDERSON-NEGELE:</strong> We offer a wide range of sensors and measuring equipments like <span style={{color:"#1F487C"}}>Temperature  Sensor
                   , Level Sensor , Pressure Sensor, Turbidity Meter, Flow Monitoring Meter, Conductivity Meter</span> that operate in a hygienic & clean production environment. The products
                    and solutions from Anderson-Negele meet the requirements of international standards. </li> 
                    <li><strong style={{color:"#1F487C"}}>CSE/Taiwan:</strong> We have recently been appointed as Distributor & Channel Partner for supply of world reputed <span style={{color:"#1F487C"}}> CSE SS Tubes, Valves & Fittings.
                     We find after seeing the CSE Products, customers are preferring CSE make SS Tubes, Valves & fittings which comes as certified products. </span> </li>
                     <li><strong style={{color:"#1F487C"}}>Alfa Laval India Ltd:</strong>  Over the years we are  supplying Alfa-Laval Spares, Valves & fittings, tubes, flow equipment.
                      M/S Alfa Laval added a wide range of various SS Flow Equipments and products that meet international approvals and the standards of manufacturing. These products 
                      are well deserved from hygiene automation system integration to processing plants installation. Its Product Range are Centrifugal Pumps, Lobe Pumps, Sanitary Heat
                     Exchangers, SS Fittings, Flow Management Valves etc  </li>  
                </ul>   
                <p></p>  
                     <p><strong>Besides above brands, we also supply said equipment of our own and proven “ASTRA” make with similar specifications & quality at competitive prices. 
                       We undertake complete turn-key solutions also through our associate companies.</strong> We being a customer centric Company, acknowledge the various requirements of our
                        customers helping them select and deploy the right equipments. We also provide after services of our supplied equipments. 
                     </p>
                     <p></p>
                     <p>We being a customer centric company, acknowledge the various requirements of our customers helping them select and deploy the right equipments .We also provide 
                       services of our Service technician to<strong>service the equipments</strong> supplied by us to the various industries.</p>           
            </li>
            <li>
            <strong style={{color: "red"}}>Project Engineering Services</strong>-
              <p></p>
              <p> Project Engineering Services popularly known as <strong>‘PES’</strong> is engaged in complete <strong>Project Execution, Erection & Installation</strong> for Process Industries like Dairy,
                 Food Processing, Breweries, Soft Drink, Confectionery Industries etc. Our Company has  dedicated, well experienced, qualified & skilled Manpower to complete
                  the Projects well in time with high quality & workmanship.  Some of the Projects handled by us are:  
             </p>
             <ul>
               <li><strong>Nestle India Ltd:</strong> Chocolate, kit-kat, Bar one, Munch, Maggie & Noodles etc. </li>
               <li><strong>Cadbury India Ltd:</strong> Chocolates Five Star, Gems, Bottled Apple Juice, Eclairs etc.</li>
               <li><strong>ITC Foods Ltd:</strong> Sugar Candy, Coca-Cola, Bottling Plants at various locations etc. </li>
               <li><strong>Pepsi India Ltd:</strong> Mineral Water, CSD projects, Concentrate Plant etc.</li>
               <li><strong>Yakult India Ltd:</strong> Yakult Milk Plant at Rai (Sonepat).</li>
               <li><strong>Seven Soul Hospitality:</strong> Instant Bear Plant at Gurgoan </li>
               <li><strong>Amul Dairy:</strong> Dairy Milk Plant (Manesar)</li>
               <li><strong>Varun Beverages:</strong> Process Piping at Greater Noida & Kosi Plants etc. </li>
             </ul>
            </li>
            <p></p>
            <li>
            <strong style={{color: "red"}}>EN Projects & Engineering Industries Pvt Ltd</strong>
              <p></p>
              <p><strong>ENP</strong>  is  one of the fastest growing Engineering Company since 1979 and engaged in<strong>Design & Manufacturing</strong> of various high quality Stainless Steel equipments 
                like Tanks, Silos, Cable Trays & Hygiene Fittings etc. used mainly in Dairy, Chocolate, Food Processing, Breweries, Soft Drink, and Confectionery Industries etc. 
                The Company is professionally managed by a group of qualified Engineers and Technocrats with vast experience in the field. 
             </p>
             <p></p>
             <strong style={{color: "red"}}>MANPOWER</strong>
             <p>We have dedicated well trained & qualified combined manpower strength of around 600.</p>
             <p></p>
             <strong style={{color: "red"}}>CONSOLIDATED TURNOVER: </strong>
             <p>Our Annual turnover is around 18 Crores. </p>
             <p></p>
             <strong style={{color: "red"}}>SPECIAL PLANNING</strong>
             <p>We manufacture modules for Dairies and Food Processing Industries</p>
            </li>
          </ol>
          <p></p>
          <h3 style={{color: "red"}}>Clientele</h3>
          <p>Our Clients include Government Departments,  Multinational  and  Top Indian Companies, like Jaipuria Group, Atlas Cycle ,Dairy Development Department,  Military  Farms, 
            Delhi milk Scheme, Mother Dairy Delhi,  Himalaya Dairy - Nepal, Bhaktapur  Dairy  - Nepal,  Integrated Dairy- Nepal,   Food  Processing , Nestle India Ltd. Smith Kline Beecham,, Milk Food ,
            Hindustan Unilever Ltd.,  Nutritional Food, Glaxo, Pepsi Cola, Alfa Laval, Tetra Pack India (P) Ltd. , NDDB, Dalmia, Sunsip,  Osram India, Lend Lease Projects and In  Breweries  - Yuksum - Punjab, IndoLownbrew,  Kalyani,  Jupiter,  Rajasthan  Breweries,  Singha Breweries  -  Nepal,  Ruchee's Breweries, Coca Cola- Perangute,  Coca Cola- (Wada) Mumbai, Coca Cola - Ghaziabad, Perfetti India Ltd., In Refrigeration York India Ltd., Subro Refrigeration, Walls Ice Cream and similar other valued customers. 
           Milk Food was completed by us with APV England. For a top multinational company we have fabricated, Erected and Tested about 200  Nos. Dairy modules, which were exported to Russia.   
           </p>
          </Grid> 
          </Grid>     
      </div>
    )
}

export default Capabilities
